import actions from './actions-file.js'
import mutations from './mutations-file.js'
import getters from './getters-file.js'
import state from './state-file.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}